import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ModeratorListing from 'views/admin/moderators/ModeratorListing'
import ModeratorForm from 'views/admin/moderators/ModeratorForm'

const Moderators = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <ModeratorListing />
      </Route>
      <Route path={`${path}/new`}>
        <ModeratorForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:moderatorId`}>
        <ModeratorForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default Moderators
